<template>
  <div class="bccNavSliderMenu-wrap">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BccNavSliderMenu',
  data () {
    return {
      items: {},
      activeIndex: ''
    }
  },
  props: {
    defaultActive: String,
    expandOnly: Boolean,
    expandGroupArr: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    defaultActive (value) {
      this.updateActiveIndex(this.items)
    }
  },
  provide () {
    return {
      rootMenu: this
    }
  },
  mounted () {
    this.$watch('items', this.updateActiveIndex)
    this.$on('item-click', this.handleItemClick)
    this.$on('groupStatus', this.handleGroup)
  },
  methods: {
    addItem (item) {
      this.$set(this.items, item.index, item)
    },
    updateActiveIndex (items) {
      for (let key in items) {
        if (key === this.defaultActive) {
          this.activeIndex = key
        }
        if (this.expandGroupArr.indexOf(key) >= 0) {
          this.items[key].setGroup(true)
        }
      }
    },
    handleItemClick (item) {
      this.activeIndex = item.index
      this.$emit('clickItem', this.activeIndex)
    },
    handleGroup () {
      let arr = []
      for (let key in this.items) {
        let item = this.items[key]
        if (item.showGroup) {
          arr.push(item.index)
        }
      }
      this.$emit('currentExpandGroup', arr)
    }
  }
}
</script>
